import { lazy } from 'react';

// Per-tenant custom homepages, keyed by subdomain (same convention as
// src/data/colors.json). Lazy-loaded so only tenants with a custom page
// download its bundle.
const customHomepages = {
    kelbrycleaningservices: lazy(() =>
        import('./kelbrycleaningservices/Homepage')
    ),
};

export default customHomepages;
